import { render } from "./SuspectDetails.vue?vue&type=template&id=39bc5c10"
import script from "./SuspectDetails.vue?vue&type=script&lang=js"
export * from "./SuspectDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__